import { Component, OnInit, Renderer2 } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';
import { Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private splashScreen: SplashScreen,
    private storage: Storage,
    private platform: Platform,
    private renderer: Renderer2,
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      if (Capacitor.isPluginAvailable('SplashScreen')) {
        this.splashScreen.hide();
      }
      if (Capacitor.isPluginAvailable('Keyboard') && this.platform.is('ios')) {
        Keyboard.setAccessoryBarVisible({ isVisible: true });
      }
    });
  }

  async ngOnInit() {
    await this.storage.create();
    this.storage.get('settings').then(settings => {
      if (settings) {
        this.renderer.setAttribute(document.body, 'color-theme', settings.darkMode ? 'dark' : 'light');
      } else {
        this.storage.set('settings', {
          darkMode: false,
          saveMedia: false,
        }).then(() => {
          this.renderer.setAttribute(document.body, 'color-theme', 'light');
        });
      }
    });
  }

}
